import { stableColor } from "..";
import { colors } from "../Theme";
import { isDarkColor } from "../Theme/utils/color-modifier";

export const getBadgeStableColors = (id: string): React.CSSProperties => {
  const backgroundColor = stableColor(id);
  const color = `${isDarkColor(backgroundColor) ? colors.hydrogen : colors.titanium900}`;

  return { backgroundColor, color };
};
